import React, { useState } from 'react';

// Dummy data for demonstration
const originalRotation = {
  rotationNumber: '4302',
  base: 'NYC',
  equipment: '73N',
  startDate: '2025-12-24',
  endDate: '2025-12-27',
  dutyPeriods: [
    {
      date: '2025-12-24',
      report: '13:15',
      release: '01:59',
      layover: 'SAT',
      hotel: 'GRAND HYATT',
      block: '5:01',
      flights: [
        { flight: 'DL1234', from: 'JFK', to: 'SAT', dep: '14:00', arr: '19:01', block: '5:01' },
      ],
    },
    {
      date: '2025-12-25',
      report: '10:00',
      release: '18:30',
      layover: 'ATL',
      hotel: 'ATL AIRPORT HOTEL',
      block: '4:15',
      flights: [
        { flight: 'DL5678', from: 'SAT', to: 'ATL', dep: '11:00', arr: '15:15', block: '4:15' },
      ],
    },
  ],
  totals: {
    schedBlock: '9:16',
    actualBlock: '9:16',
    duty: '20:00',
    tafb: '36:00',
  },
};

const rerouteRotation = {
  ...originalRotation,
  dutyPeriods: [
    originalRotation.dutyPeriods[0],
    {
      ...originalRotation.dutyPeriods[1],
      block: '5:00',
      flights: [
        { flight: 'DL5678', from: 'SAT', to: 'ATL', dep: '11:00', arr: '16:00', block: '5:00' },
      ],
    },
  ],
  totals: {
    schedBlock: '10:01',
    actualBlock: '10:01',
    duty: '21:00',
    tafb: '37:00',
  },
};

function highlightChange(orig, reroute) {
  return orig !== reroute && orig !== undefined ? (
    <span style={{ textDecoration: 'line-through', color: '#b71c1c', marginRight: 4 }}>{orig}</span>
  ) : null;
}

export default function GraphicsWireframe() {
  const [view, setView] = useState('ab'); // 'ab' or 'merged'

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', background: '#f7f9fa', minHeight: '100vh', padding: 32 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 32 }}>
        <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 8 }}>Rotation {originalRotation.rotationNumber} — Graphics Wireframe</h2>
        <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
          <button onClick={() => setView('ab')} style={{ background: view==='ab' ? '#1976d2' : '#e3eafc', color: view==='ab' ? '#fff' : '#1976d2', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>A/B View</button>
          <button onClick={() => setView('merged')} style={{ background: view==='merged' ? '#1976d2' : '#e3eafc', color: view==='merged' ? '#fff' : '#1976d2', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>Merged View</button>
        </div>
        {/* Totals Bar */}
        <div style={{ display: 'flex', gap: 32, marginBottom: 32, fontSize: 18 }}>
          <div><b>Sched Block:</b> {view==='ab' ? (<><span>{originalRotation.totals.schedBlock}</span> <span style={{ color: '#888', margin: '0 8px' }}>→</span> <span>{rerouteRotation.totals.schedBlock}</span></>) : (<>{highlightChange(originalRotation.totals.schedBlock, rerouteRotation.totals.schedBlock)}<span style={{ color: rerouteRotation.totals.schedBlock !== originalRotation.totals.schedBlock ? '#1976d2' : undefined }}>{rerouteRotation.totals.schedBlock}</span></>)} </div>
          <div><b>Actual Block:</b> {view==='ab' ? (<><span>{originalRotation.totals.actualBlock}</span> <span style={{ color: '#888', margin: '0 8px' }}>→</span> <span>{rerouteRotation.totals.actualBlock}</span></>) : (<>{highlightChange(originalRotation.totals.actualBlock, rerouteRotation.totals.actualBlock)}<span style={{ color: rerouteRotation.totals.actualBlock !== originalRotation.totals.actualBlock ? '#1976d2' : undefined }}>{rerouteRotation.totals.actualBlock}</span></>)} </div>
          <div><b>Duty:</b> {view==='ab' ? (<><span>{originalRotation.totals.duty}</span> <span style={{ color: '#888', margin: '0 8px' }}>→</span> <span>{rerouteRotation.totals.duty}</span></>) : (<>{highlightChange(originalRotation.totals.duty, rerouteRotation.totals.duty)}<span style={{ color: rerouteRotation.totals.duty !== originalRotation.totals.duty ? '#1976d2' : undefined }}>{rerouteRotation.totals.duty}</span></>)} </div>
          <div><b>TAFB:</b> {view==='ab' ? (<><span>{originalRotation.totals.tafb}</span> <span style={{ color: '#888', margin: '0 8px' }}>→</span> <span>{rerouteRotation.totals.tafb}</span></>) : (<>{highlightChange(originalRotation.totals.tafb, rerouteRotation.totals.tafb)}<span style={{ color: rerouteRotation.totals.tafb !== originalRotation.totals.tafb ? '#1976d2' : undefined }}>{rerouteRotation.totals.tafb}</span></>)} </div>
        </div>
        {/* Duty Periods */}
        <div style={{ display: 'flex', flexDirection: view==='ab' ? 'row' : 'column', gap: 32 }}>
          {view==='ab' ? (
            <>
              <div style={{ flex: 1 }}>
                <h4 style={{ color: '#1976d2', fontWeight: 600, marginBottom: 12 }}>Original</h4>
                {originalRotation.dutyPeriods.map((dp, i) => (
                  <DayCard key={i} duty={dp} />
                ))}
              </div>
              <div style={{ flex: 1 }}>
                <h4 style={{ color: '#b71c1c', fontWeight: 600, marginBottom: 12 }}>Reroute</h4>
                {rerouteRotation.dutyPeriods.map((dp, i) => (
                  <DayCard key={i} duty={dp} />
                ))}
              </div>
            </>
          ) : (
            <div>
              {rerouteRotation.dutyPeriods.map((dp, i) => {
                const orig = originalRotation.dutyPeriods[i] || {};
                return <DayCard key={i} duty={dp} orig={orig} highlight />;
              })}
            </div>
          )}
        </div>
        {/* Legend */}
        <div style={{ marginTop: 40, fontSize: 15, color: '#555' }}>
          <b>Legend:</b> <span style={{ textDecoration: 'line-through', color: '#b71c1c' }}>Strikethrough</span> = original value, <span style={{ color: '#1976d2' }}>Blue</span> = changed value
        </div>
      </div>
    </div>
  );
}

function DayCard({ duty, orig = {}, highlight }) {
  return (
    <div style={{ background: '#f4f8fb', borderRadius: 8, padding: 20, marginBottom: 18, boxShadow: '0 1px 4px #0001' }}>
      <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>{duty.date} — {duty.layover} <span style={{ color: '#888', fontWeight: 400 }}>({duty.hotel})</span></div>
      <div style={{ display: 'flex', gap: 24, fontSize: 15, marginBottom: 6 }}>
        <div><b>Report:</b> {highlight ? <>{highlightChange(orig.report, duty.report)}<span style={{ color: duty.report !== orig.report ? '#1976d2' : undefined }}>{duty.report}</span></> : duty.report}</div>
        <div><b>Release:</b> {highlight ? <>{highlightChange(orig.release, duty.release)}<span style={{ color: duty.release !== orig.release ? '#1976d2' : undefined }}>{duty.release}</span></> : duty.release}</div>
        <div><b>Block:</b> {highlight ? <>{highlightChange(orig.block, duty.block)}<span style={{ color: duty.block !== orig.block ? '#1976d2' : undefined }}>{duty.block}</span></> : duty.block}</div>
      </div>
      <div style={{ fontSize: 14, color: '#444' }}>
        {duty.flights.map((f, idx) => (
          <div key={idx} style={{ marginBottom: 2 }}>
            <b>{f.flight}</b>: {highlight ? <>{highlightChange(orig.flights?.[idx]?.from, f.from)}<span style={{ color: f.from !== orig.flights?.[idx]?.from ? '#1976d2' : undefined }}>{f.from}</span></> : f.from} → {highlight ? <>{highlightChange(orig.flights?.[idx]?.to, f.to)}<span style={{ color: f.to !== orig.flights?.[idx]?.to ? '#1976d2' : undefined }}>{f.to}</span></> : f.to} | Dep: {highlight ? <>{highlightChange(orig.flights?.[idx]?.dep, f.dep)}<span style={{ color: f.dep !== orig.flights?.[idx]?.dep ? '#1976d2' : undefined }}>{f.dep}</span></> : f.dep} | Arr: {highlight ? <>{highlightChange(orig.flights?.[idx]?.arr, f.arr)}<span style={{ color: f.arr !== orig.flights?.[idx]?.arr ? '#1976d2' : undefined }}>{f.arr}</span></> : f.arr} | Block: {highlight ? <>{highlightChange(orig.flights?.[idx]?.block, f.block)}<span style={{ color: f.block !== orig.flights?.[idx]?.block ? '#1976d2' : undefined }}>{f.block}</span></> : f.block}
          </div>
        ))}
      </div>
    </div>
  );
}
